// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Fw-z","tooltipWrapper":"Gw-z","icon":"Hw-z","tooltip":"Iw-z","content":"Jw-z"};